<el-site-header class="header-fixed"></el-site-header>
<mat-drawer-container class="layout-container" [hasBackdrop]="isHandset">
    <mat-drawer #drawer [mode]="(isHandset) ? 'over' : 'side'" class="footer-fixed" [opened]="!isHandset">
        <el-site-sidemenu></el-site-sidemenu>
    </mat-drawer>
    <mat-drawer-content class="main">
        <router-outlet></router-outlet>
    </mat-drawer-content>
</mat-drawer-container>
<el-site-footer></el-site-footer>